import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppLoginSubjectExtQueryCriteriaClass extends BaseCriteriaModel {
  login_subject_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class AppLoginSubjectExtCriteriaModelQuery {
  query = '';

  constructor(appLoginSubjectExtCriteriaModel: AppLoginSubjectExtQueryCriteriaClass) {

    if (!appLoginSubjectExtCriteriaModel) {
      return;
    }

    this.query += appLoginSubjectExtCriteriaModel.login_subject_guid.filter(x => x !== '').map(x => '&login_subject_guid=' + x).orElse('');
    this.query += appLoginSubjectExtCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += appLoginSubjectExtCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += appLoginSubjectExtCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += appLoginSubjectExtCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');

    this.query += '&status=' + appLoginSubjectExtCriteriaModel.status;
    this.query += '&orderBy=' + appLoginSubjectExtCriteriaModel.orderBy;
    this.query += '&order=' + appLoginSubjectExtCriteriaModel.order;
    this.query += '&offset=' + appLoginSubjectExtCriteriaModel.offset + '&limit=' + appLoginSubjectExtCriteriaModel.limit;
  }
}
